/* Explicit storefront actions. Checkout requested is not checkout reached or purchase. */
(() => {
  const script = document.currentScript;
  const pending = [];
  let retries = 0;
  let timer;
  const flush = () => {
    try {
      if (typeof window.clarity === 'function') {
        while (pending.length) window.clarity('event', pending.shift());
        clearInterval(timer);
        timer = undefined;
      } else if (++retries >= 60) {
        pending.length = 0;
        clearInterval(timer);
        timer = undefined;
      }
    } catch (_) { /* Analytics must never interrupt shopping. */ }
  };
  window.sgoClarityEvent = (name) => {
    try {
      pending.push(name);
      retries = 0;
      flush();
      if (pending.length && !timer) timer = setInterval(flush, 500);
    } catch (_) { /* Keep commerce available when tracking is blocked. */ }
  };
  const pageType = script?.dataset.pageType;
  const pagePath = script?.dataset.pagePath;
  if (pageType === 'product') window.sgoClarityEvent('sgo_product_page_view');
  if (pageType === 'cart') window.sgoClarityEvent('sgo_cart_page_view');
  if (pagePath === '/pages/at-home-soccer-training') window.sgoClarityEvent('sgo_paid_landing_view');
  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented) return;
    if (event.submitter?.name === 'checkout') window.sgoClarityEvent('sgo_checkout_requested');
  });
})();
